import { contentsType } from '../types';

const chartbitContents: Array<contentsType> = [
  {
    title: '15 Tahun Price History',
    description:
      'Lihat tren harga saham sampai dengan 15 tahun kebelakang untuk menganalisa tren jangka panjang.',
    image: 'Chartbit_15_Years_Blue.jpg',
  },
  {
    title: 'Bandarmologi',
    description:
      'Deteksi dan pelajari gerak bandar, jadilah teman bandar untuk membantu kamu mendapatkan keuntungan. Gunakan indikator bandarmologi untuk mempelajari akumulasi dan distribusi para bandar.',
    image: 'Chartbit_Bandarmology_Blue.jpg',
  },
  {
    title: 'Corporate Action Event',
    description:
      'Pantau pergerakan harga pada saat ex date dari aksi korporasi yang dilakukan seperti pembagian dividen, stock split atau right issue.',
    image: 'Chartbit_Corp_Event_Blue.jpg',
  },
  {
    title: '100+ Technical Indikator',
    description:
      'Tersedia ratusan indikator siap pakai untuk mempertajam analisa teknikal Anda. Mulai dari indikator dasar seperti Moving Average, MACD, RSI sampai indikator khusus dari Stockbit seperti Bandar Value dan Foreign Flow.',
    image: 'Chartbit_Indicator_Blue.jpg',
  },
  {
    title: 'Foreign Flow',
    description:
      'Pantau pergerakan dana asing di saham pilihanmu, apakah net inflow atau outflow. Pelajari juga seberapa kuat transaksi dana asing pada saham tersebut.',
    image: 'Chartbit_Foreign_Blue.jpg',
  },
];

const additionalInfos = [
  {
    title: 'Real-time Price',
    description:
      'Data price di chartbit merupakan data terkini dari harga di pasar. Data price akan berubah dengan sendirinya jika ada perubahan data di pasar karena Chartbit terintegrasi langsung dengan server IDX.',
  },
  {
    title: 'Intraday Price Interval',
    description:
      'Selain periode daily, weekly dan monthly. Kamu juga bisa memilih periode chartbit mulai dari 1 menit, 5 menit, 30 menit, sampai 1 jam.',
  },
];

export { chartbitContents, additionalInfos };
